import { ESITI, type Esito } from "./esitiApi";

/**
 * I quattro tasti «che fine fa la merce». Un clic salva. Quello proposto è
 * pieno (verde), gli altri sono bordati: la proposta si vede, ma non è obbligata.
 * A 390px vanno su due colonne, ognuno alto almeno 44px.
 */
export function BottoniEsito({
  proposta,
  disabled,
  onScegli,
  ariaPrefisso,
}: {
  proposta: Esito | null;
  disabled: boolean;
  onScegli: (e: Esito) => void;
  /** Per i lettori di schermo: «Ordine X: Buttata». */
  ariaPrefisso?: string;
}) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
      {ESITI.map((e) => {
        const consigliato = proposta === e.id;
        return (
          <button
            key={e.id}
            type="button"
            disabled={disabled}
            aria-label={ariaPrefisso ? `${ariaPrefisso}: ${e.label}` : undefined}
            onClick={() => onScegli(e.id)}
            className={`inline-flex min-h-[44px] items-center justify-center rounded-md border px-3 text-[13px] font-semibold leading-tight transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 ${
              consigliato
                ? "border-emerald-700 bg-emerald-700 text-white hover:bg-emerald-800"
                : "border-line-2 bg-card text-ink hover:border-ink-4 hover:bg-paper"
            }`}
          >
            {e.label}
          </button>
        );
      })}
    </div>
  );
}
